import * as types from '../actionType'

const initialState = []

const forgetPass = (state = initialState, action) => {
    switch (action.type) {
        case types.FORGET_PASS:
            return action.payload
        default:
            return state
    }
}

export {forgetPass};